import { useWallet } from "@solana/wallet-adapter-react";
import { Fragment, useContext, useEffect, useState } from "react";

import { getUserRequest } from "../../api/users.api";
import { UserContext } from "../../contexts/userContext";
import { toggleModalOpenClass } from "../../utilities/helpers";
import Modal from "../Modal/Modal";
import UserSettingsForm from "../UserSettingsForm/UserSettingsForm";
import "./WalletModal.scss";

const WalletModal = () => {
  const { publicKey, disconnect } = useWallet();
  const [isWalletModalActive, toggleModalState] = useState(false);
  const { updateUser, adminData } = useContext(UserContext);

  useEffect(() => {
    async function createUserAndOpenModalIfNecessary() {
      if (!publicKey) {
        updateUser(undefined);
        return;
      }
      try {
        const user = await getUserRequest(publicKey.toString());
        if (!user && adminData) {
          toggleModalState(true);
        } else {
          updateUser(user);
        }
      } catch (error) {
        console.log(error);
        await disconnect();
      }
    }

    void createUserAndOpenModalIfNecessary();
  }, [publicKey, adminData]);

  return (
    <Fragment>
      {isWalletModalActive && (
        <Modal>
          <div className="wallet-modal__content">
            <h3>Welcome, help us get to know you better!</h3>
            <p className="wallet-modal__welcome-info">
              Create your profile to connect with other members and get easily
              recognized.
            </p>
            <UserSettingsForm
              closeModal={() => {
                toggleModalOpenClass(false);
                toggleModalState(false);
              }}
            />
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default WalletModal;
